import Programmes from "../components/Programmes";
import FAQ from "../components/FAQ";
import { CS_FAQS } from "../data/faq-data";
import { PROGRAMMES_PAGE } from "../data/programmes";

export default function ProgrammesPage() {
    return (
        <main className="pt-24" data-testid="programmes-page">
            <section className="max-w-7xl mx-auto px-4 sm:px-8 py-12">
                <p className="text-xs uppercase tracking-[0.3em] text-aiorange font-bold mb-3">
                    {PROGRAMMES_PAGE.tag}
                </p>
                <h1 className="font-display font-black text-4xl sm:text-6xl tracking-tighter leading-[1.05] max-w-4xl">
                    {PROGRAMMES_PAGE.headlineLead}{" "}
                    <span className="text-aiblue">{PROGRAMMES_PAGE.headlineHighlight}</span>
                </h1>
                <p className="mt-5 text-lg text-gray-600 max-w-2xl">
                    {PROGRAMMES_PAGE.description}
                </p>
            </section>
            <Programmes />
            <FAQ
                tag={PROGRAMMES_PAGE.faqTag}
                headline={PROGRAMMES_PAGE.faqHeadline}
                items={{
                    student: CS_FAQS.student,
                    university: CS_FAQS.university,
                }}
                tabs={true}
            />
        </main>
    );
}
